<template>
  <div class="login-page">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="d-none d-sm-none d-md-block col-12 col-md-6 offset-xl-2 offset-md-1 order-md-2 mb-5 mb-md-0"
        >
          <div class="text-center">
            <img src="/theme/img/illustrations/happiness.svg" alt="..." class="img-fluid" />
          </div>
        </div>
        <div class="col-12 col-md-5 col-xl-4 order-md-1 my-5">
          <h1 class="display-4 text-center mb-3">Info Needed</h1>
          <AddInfoForm @authenticated="authenticated" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddInfoForm from '@/components/Auth/AddInfoForm'
import { initRouterView } from '@/router'

export default {
  name: 'LinkMissingAccountInfoPage',
  components: {
    AddInfoForm
  },
  methods: {
    authenticated() {
      initRouterView(this)
    }
  }
}
</script>

<style scoped lang="scss">
.login-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
